export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5739.e859f3b5.jpg";